const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "[::1]"]);

/**
 * 실결제 없는 테스트 완료 버튼을 노출해도 되는 API 호스트인지 판별한다.
 * 운영 호스트에서는 반드시 false를 반환한다.
 *
 * @param {string} apiHost VUE_APP_HOST
 * @returns {boolean}
 */
export function isTestPaymentApiHost(apiHost) {
  if (typeof apiHost !== "string" || !apiHost.trim()) return false;

  try {
    const { hostname } = new URL(apiHost);
    const normalizedHostname = hostname.toLowerCase();

    return LOCAL_HOSTNAMES.has(normalizedHostname) || normalizedHostname.includes("dev-");
  } catch (_error) {
    return false;
  }
}
